import * as React from 'react'

export const HeadingIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19.5 22.1997V2.69971H15.75V10.0122H8.25V2.69971H4.5V22.1997H8.25V13.6685H15.75V22.1997H19.5Z'
        fill='currentColor'
      />
    </svg>
  )
})

HeadingIcon.displayName = 'HeadingIcon'
